import React from 'react';
import AppConfig from "../../services/AppConfig";

interface Props {
    icon: JSX.Element;
    size?: 'large' | "medium" | "small";
    className?: string;
    color?: "warning" | "primary" | "success" | "danger";
}

const RoundedIcon = ({icon, size, className, color}: Props) => {
    return (
        <div className={`rounded-icon ${color ? `text-${color}` : ""} ${size ? size : "large"} ${className ?? ""}`}>
            {!AppConfig.isDarkMode() && <div className="ellipse"/>}
            {icon}
        </div>
    )
}

export default RoundedIcon;